import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import Checkbox from 'app/components/shared/Checkbox';
import StickyToolbar from 'app/components/shared/stickyToolbar';

import './BatchActionsControls.scss';

export default function BatchActionsControls({ list, updateAll, selectedItems, sticky = false, children }) {
  const Tag = sticky ? StickyToolbar : 'div';
  return (
    <Tag>
      <div className="cp-batch-action-controls">
        <div className="master-checkbox" data-key="batch-action-controls">
          <FormattedMessage id="batch_action_select_items" values={{ count: list.size }}>
            {label => (
              <Checkbox
                checked={selectedItems.size === list.size}
                dataKey="batch-actions-master"
                handleChange={updateAll}
                id="batch-actions-master"
                label={label}
              />
            )}
          </FormattedMessage>
        </div>
        <div className="action-buttons">{children}</div>
      </div>
    </Tag>
  );
}

BatchActionsControls.propTypes = {
  list: ImmutablePropTypes.list.isRequired,
  updateAll: PropTypes.func.isRequired,
  selectedItems: ImmutablePropTypes.map.isRequired,
  sticky: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
